'use client';

import { useMemo } from 'react';
import { useAreFeatureFlagsLoading } from '@frameio/feature-flags';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { useGetHasSearchEnabledQuery } from '../quick-search/gql/generated/GetHasSearchEnabled';

export const useIsQuickSearchV2Enabled = () => {
  const accountId = useActiveAccountId();
  const areFeatureFlagsLoading = useAreFeatureFlagsLoading();
  const { data, loading } = useGetHasSearchEnabledQuery({
    variables: {
      accountId,
    },
    skip: !accountId,
    fetchPolicy: 'cache-first',
  });

  const canUseNewQuickSearch =
    Boolean(data?.account?.canUseNewQuickSearch) ?? false;

  return useMemo(
    () => ({
      isEnabled: canUseNewQuickSearch,
      isLoading: areFeatureFlagsLoading || loading,
    }),
    [areFeatureFlagsLoading, canUseNewQuickSearch, loading]
  );
};
